const Sparkle = ({
  color = '#E9BF6E',
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.25 4.25L14.7763 9.72368L20.25 12.25L14.7763 14.7763L12.25 20.25L9.72368 14.7763L4.25 12.25L9.72368 9.72368L12.25 4.25Z"
        stroke={color}
        strokeWidth="2"
      />
      <path d="M5.8 3.7L4.75 1.25L3.7 3.7L1.25 4.75L3.7 5.8L4.75 8.25L5.8 5.8L8.25 4.75L5.8 3.7Z" fill={color} />
    </svg>
  );
};

export default Sparkle;
